import React, { Suspense,useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import FloorplansServerComponent from "./components/floorplans/floorplanListing/floorplansServerComponent";
import FloorplanDetails from "./components/floorplans/floorplanDetails/floorplanDetails";
import "./styles/style.scss";
import Sightmap from "./components/sightmap/sightmap";

function App() {


  return (
    <>
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/find-your-home/availability" />} />
        <Route
            path="/find-your-home/availability"
            element={
              <Suspense key={new URLSearchParams(window.location.search)}>
                <FloorplansServerComponent typeListing={true} />
              </Suspense>
            }
          />
          <Route
            path="/find-your-home/availability/:floorplanName/:floorplanId"
            element={
              <Suspense key={new URLSearchParams(window.location.search)}>
                <FloorplansServerComponent typeListing={false} />
              </Suspense>
            }
          />
          <Route
            path="/find-your-home/availability/:floorplanName/:floorplanId/apartments/:apartmentName/:apartmentId"
            element={
              <Suspense key={new URLSearchParams(window.location.search)}>
                <FloorplanDetails />
              </Suspense>
            }
          />
        <Route
          path="/find-your-home/sightmap"
          element={
            <Suspense key={new URLSearchParams(window.location.search)}>
              <Sightmap />
            </Suspense>
          }
        />
      </Routes>
    </Router>

    </>
  );
}

export default App;
